import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "fixed-sn" }
const _hoisted_2 = { class: "wrapper w-full max-w-none" }
const _hoisted_3 = { class: "pt-22.5 pb-4 lg:pt-20.5 lg:ml-65 px-4" }
const _hoisted_4 = {
  "aria-label": "breadcrumb",
  class: "my-4"
}
const _hoisted_5 = { class: "flex items-center text-sm lg:text-base text-primary-font font-bold leading-none" }
const _hoisted_6 = {
  key: 0,
  class: "mx-2 text-primary-font"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_Overlay = _resolveComponent("Overlay")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Nav, { "toggle-sidebar": _ctx.toggleSidebar }, null, 8, ["toggle-sidebar"]),
      (_ctx.isSidebarActive)
        ? (_openBlock(), _createBlock(_component_Overlay, {
            key: 0,
            class: "lg:hidden",
            onClick: _ctx.toggleSidebar
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Sidebar, {
        "is-active": _ctx.isSidebarActive,
        "toggle-sidebar": _ctx.toggleSidebar
      }, null, 8, ["is-active", "toggle-sidebar"]),
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("ol", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.globalBreadcrumb, (data, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "flex items-center"
              }, [
                (index !== 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "/"))
                  : _createCommentVNode("", true),
                (_openBlock(), _createBlock(_resolveDynamicComponent(data.isSub ? 'router-link' : 'span'), {
                  to: data.route,
                  class: "hover:text-primary transition"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(data.displayName)), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}